import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { setFilterToSystemDefault, setWellListExtent } from "store/features";
import {
  setFilterToSystemDefault as setFacilityFilterToSystemDefault,
  setWellListExtent as setFacilityWellListExtent
} from "store/features/filter/facilityFilterSlice";

/**
 * Shared hook for undoing both well and facility filters.
 * This restores the previous filter state for both filter types.
 */
export const useFilterUndo = () => {
  const dispatch = useDispatch();

  const undoFilters = useCallback(() => {
    dispatch(setFilterToSystemDefault());
    dispatch(setFacilityFilterToSystemDefault());

    // Clear the filter extents to prevent unwanted zooming after undoing midstream filters
    dispatch(setWellListExtent(undefined));
    dispatch(setFacilityWellListExtent(undefined));
  }, [dispatch]);

  return { undoFilters };
};
